import type { Snapshot } from '@ember-data/legacy-compat/-private';
import type { BudgetForecastEntry } from 'lumen/models';
import ApplicationSerializer from 'lumen/serializers/application';

export default class SegmentSerializer extends ApplicationSerializer {
  modelNameFromPayloadKey(key: string): string {
    if (key === 'entry' || key === 'entries') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey('budget-forecast/entry');
    }

    if (key === 'users') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey('budget-forecast/user');
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return super.modelNameFromPayloadKey(key);
  }

  normalizeCreateRecordResponse(
    store: unknown,
    primaryModelClass: unknown,
    payload: object,
    id: string | number,
    requestType: string,
  ): unknown {
    /**
     * By default, RESTSerializer expects the payload to be wrapped in a root key.
     * For the createRecord response, we want to wrap the payload in the appropriate root key.
     */
    const restPayload = { 'budget-forecast/entry': payload };
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    return super.normalizeCreateRecordResponse(
      store,
      primaryModelClass,
      restPayload,
      id,
      requestType,
    );
  }

  payloadKeyFromModelName(): string {
    return 'entry';
  }

  serialize(snapshot: Snapshot<BudgetForecastEntry>, options: object): unknown {
    if (snapshot.isNew) {
      return { title: snapshot.record?.title ?? '' };
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    return super.serialize(snapshot, options);
  }

  serializeIntoHash(
    hash: BudgetForecastEntry,
    _ModelClass: unknown,
    snapshot: Snapshot<BudgetForecastEntry>,
    options: object,
  ): void {
    /**
     * By default, RESTSerializer uses the model name as the root key.
     * For this serializer, we want to avoid having a root key entirely.
     */
    Object.assign(hash, this.serialize(snapshot, options));
  }
}
